import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  m_title: {
    textTransform: "capitalize",
  },
}));
// text-transform: capitalize;
export { useStyles };
